import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  static AUTH_TOKEN_KEY = 'auth_token';
  static REFRESH_TOKEN_KEY = 'refresh_token';
  static PATH_REFRESH_TOKEN = 'refresh_token_url';
  static USER_ID_KEY = 'user_id';
  static TENANT_KEY = 'tenant';
  static TENANT_NAME_KEY = 'tenant_name';
  static TOKEN_EXPIRE_DATE = 'token_expire_date';
  static ENTRA_KEY = 'entra';

  constructor() {}

  userIsLoggedIn() {
    let token = sessionStorage.getItem(LoginService.AUTH_TOKEN_KEY);
    if (!token) {
      return false;
    }
    const payload: { eat: number; iat: number; tenantId: string; id: string } = jwtDecode(token);
    return Date.now() < payload.eat;
  }

  /**
   * Get token
   */
  getToken(): string | null {
    //return 'abcd-efgh-1234-5678';
    return sessionStorage.getItem(LoginService.AUTH_TOKEN_KEY);
  }

  /**
   * Set Token
   */
  setToken(token: string): void {
    sessionStorage.setItem(LoginService.AUTH_TOKEN_KEY, token);
  }

  /**
   * Get user_id
   */
  getUserId(): string | null {
    return sessionStorage.getItem(LoginService.USER_ID_KEY);
  }

  /**
   * Set user_id
   */
  setUserId(userId: string) {
    sessionStorage.setItem(LoginService.USER_ID_KEY, userId);
  }

  /**
   * Get user Tenant
   */
  getUserTenant(): string | null {
    return sessionStorage.getItem(LoginService.TENANT_KEY);
  }

  /**
   * Set tenant id
   */
  setTenant(tenantId: string) {
    sessionStorage.setItem(LoginService.TENANT_KEY, tenantId);
  }

  /**
   * Get user Tenant name
   */
  getTenantName(): string | null {
    return sessionStorage.getItem(LoginService.TENANT_NAME_KEY);
  }

  /**
   * Set tenant name
   */
  setTenantName(tenantName: string) {
    sessionStorage.setItem(LoginService.TENANT_NAME_KEY, tenantName);
  }

  /**
   * Set Refresh token
   */
  setRefresh(refresh: string): void {
    sessionStorage.setItem(LoginService.REFRESH_TOKEN_KEY, refresh);
  }

  /**
   * Get Refresh token
   */
  getRefresh(): string | null {
    return sessionStorage.getItem(LoginService.REFRESH_TOKEN_KEY);
  }

  /**
   * Clear Token and Refresh Token
   */
  clearToken(): void {
    sessionStorage.clear();
  }

  setApiUrlRefreshToken(url: string) {
    sessionStorage.setItem(LoginService.PATH_REFRESH_TOKEN, url);
  }

  getApiUrlRefreshToken(): string {
    return sessionStorage.getItem(LoginService.PATH_REFRESH_TOKEN) || '';
  }

  /**
   * get token_expire_date
   */
  setTokenExpireDate(token_expire_date: string) {
    sessionStorage.setItem(LoginService.TOKEN_EXPIRE_DATE, token_expire_date);
  }

  /**
   * Set token_expire_date
   */
  getTokenExpireDate(): string | null {
    return sessionStorage.getItem(LoginService.TOKEN_EXPIRE_DATE);
  }

  setEntra(value: string): void {
    localStorage.setItem(LoginService.ENTRA_KEY, value);
  }

  getEntra(): boolean {
    return localStorage.getItem(LoginService.ENTRA_KEY) === 'true';
  }

  clearEntra(): void {
    localStorage.removeItem(LoginService.ENTRA_KEY);
  }
}
